import TextToolTip from "@lhd/components/TextToolTip";
import { AppPartType } from "../AppForm/types";
import { getConfigAppPartType } from "../utils";

interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  children?: React.ReactNode;
  styleColor?: React.CSSProperties;
}

const AutoFill = (props: IProps) => {
  const {
    item,
    isDisable,
    preview,
    isTable,
    children,
    styleColor = {},
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const isShowOnlyValue = !preview && isTable && isDisable;

  return (
    <>
      {isHiddenLabel || isTable ? (
        ""
      ) : (
        <label
          className="ant-form-item-required ant-form-item-label"
          style={{
            padding: "4px 0 4px",
            display: "block",
          }}
        >
          {labelText}
        </label>
      )}
      <div
        className="auto-filled"
        style={
          isShowOnlyValue
            ? {
                paddingLeft: "2px",
              }
            : {
                background: "#fff",
                height: "44px",
                border: "1px solid #d9d9d9",
                padding: "10px",
                color: "black",
                ...styleColor,
              }
        }
      >
        <TextToolTip>{children || "(自動入力)"}</TextToolTip>
      </div>
    </>
  );
};

export default AutoFill;
